import React from 'react';
import styled from 'styled-components';

export const modalContentStyle: React.CSSProperties = {
  minWidth: 306,
  minHeight: 365,
  maxWidth: 830,
  padding: '50px 40px',
  height: 'auto',
  width: 'auto',
  border: 'none',
  borderRadius: 16,
  textAlign: 'left',
  marginTop: 130,
  position: 'relative',
  fontSize: 16,
};

export const Content = styled.div`
  h3 {
    margin: 0;
    font-size: 16px;
    font-family: Poppins-SemiBold, sans-serif;
  }
  ul {
    margin: 5px 0 0;
    font-family: Poppins-Regular, sans-serif;
    padding-left: 20px;
  }
`;
